import { BasicRequest } from "./basicRequest";

export class UndeleteMoovConfigurationRequest extends BasicRequest{
    public moovConfigurationId! : number;
}